const ScoreBadge = ({ score, label }: { score: number; label: string }) => {
  const color =
    score >= 75 ? 'text-green-600' :
    score >= 50 ? 'text-amber-500' :
    'text-red-500';

  return (
    <div className="flex flex-col items-center gap-1 p-4 rounded-xl border border-border bg-muted/40">
      <span className={`text-3xl font-bold font-fraunces ${color}`}>{score}</span>
      <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
    </div>
  );
};

export default ScoreBadge;
